const initialState = {
    tasks: []
};

const aiTasksReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_AI_TASKS':
            return {
                ...state,
                tasks: action.payload
            };
        default:
            return state;
    }
};

export default aiTasksReducer;